/** Main JSON SAS on a catalog row (`sas` / `SAS` from API). */
export function pickMainSasFromCatalogRow(row: Record<string, unknown>): string | null {
  const v = row.sas ?? row.SAS;
  return typeof v === "string" && v.trim().length > 0 ? v.trim() : null;
}
